export default __webpack_public_path__ + "static/media/04-main.bcff2a67.jpg";